import {initializeSentry} from '@js/modules/sentry';
import {patchWorkerErrorReporting} from '@js/modules/workerErrorReporting';

// import cookieChoices from '@/components/layout/cookieChoices';

initializeSentry();

// Forward uncaught errors from every Web Worker to Sentry — they don't
// reach the main-thread handler on their own. Must run before any worker is created.
patchWorkerErrorReporting();

//     document.addEventListener('DOMContentLoaded', function () {
//         setTimeout(function () {
//             cookieChoices.displayCookies(window.termsUrl);
//         }, 3000);
//     });
